import styled from 'styled-components';
import { commonContentPositionStyle } from '@race-planner-web/app-page';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { forExtraSmallDevices } from '@race-planner-web/app-theme';

export const ContentContainer = styled.div`
    ${commonContentPositionStyle};
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    background-color: ${({ theme: { colors: { background } } }) => background};
    padding-bottom: 24px;
`;

export const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const CalculatorContainer = styled.div`
    flex: 1 0 auto;
    margin-top: 20px;
`;

export const CalculateButton = styled(PrimaryButton)`
    margin-top: 10px;
    max-width: fit-content;

    ${forExtraSmallDevices(
        `
            max-width: 100%;
            width: 100%;
        `
    )}
`;

export const HighlighDisabled = styled.div`
    & label.ms-Label,
    & span.ms-Dropdown-title,
    & input.ms-TextField-field {
        color: ${({ theme: { colors: { text } } }) => text};
    }
`;
